module.exports = __webpack_public_path__ + "img/pop-up-ejemplo.cad87e0d.png";